import styles from "./DefaultLayout.module.css";
const DefaultLayout = ({ children }) => {
      return <div className={styles.pageLayout}>{children}</div>;
};

export default DefaultLayout;
